@if (auth.isLoggedIn()) {
  <button
    type="button"
    class="flex items-center gap-2 rounded-lg px-2 py-1 hover:bg-surface-500/10 transition-colors cursor-pointer select-none"
    aria-haspopup="menu"
    (click)="openMenu($event)"
  >
    <div
      class="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-white text-xs font-semibold"
    >
      {{ auth.initials() }}
    </div>
    <div class="hidden sm:flex flex-col leading-tight text-left">
      <span class="text-sm font-medium text-content-fg">{{
        auth.displayName()
      }}</span>
      <span class="text-xs text-surface-500">{{
        auth.currentUser()?.email
      }}</span>
    </div>
    <i class="pi pi-chevron-down text-xs text-surface-400 hidden sm:block"></i>
  </button>

  <ui-menu #userMenu>
    <ui-menu-item
      [title]="'topbar.profile' | transloco"
      icon="pi pi-user"
      (selectItem)="openProfile()"
    />

    @if (tenants().length) {
      <ui-menu-separator />
      <ui-menu-section [title]="'topbar.workspaces' | transloco" />
      @for (tenant of tenants(); track tenant.id) {
        <ui-menu-item
          [title]="tenant.name"
          icon="pi pi-building"
          [selected]="tenant.externalId === currentTenantId()"
          (selectItem)="switchTenant(tenant.externalId)"
        />
      }
    }

    <ui-menu-separator />
    <ui-menu-item
      [title]="'topbar.newWorkspace' | transloco"
      icon="pi pi-plus"
      (selectItem)="openNewWorkspace()"
    />

    <ui-menu-separator />
    <ui-menu-item
      [title]="'topbar.signOut' | transloco"
      icon="pi pi-sign-out"
      [danger]="true"
      (selectItem)="signOut()"
    />
  </ui-menu>
} @else {
  <ui-button
    variant="primary"
    [label]="'common.auth.signIn' | transloco"
    (click)="auth.login()"
  />
}
